import React from 'react';
import TempBackImage from '../assets/background.jpg';

const typesData = [
  {
    num: '01',
    title: 'ADPKD',
    desc: 'ADPKD is the most common inherited kidney disorder, occurring in 1 in 1000 to 1 in 400 births. It causes progressive kidney damage, affecting families with lifelong health and economic challenges.',
  },
  {
    num: '02',
    title: 'ARPKD',
    desc: 'ARPKD is a rare childhood-onset disease affecting kidneys, liver, and biliary tract. Some children develop kidney failure in infancy, while others face it later. Its incidence is estimated at 1 in 20,000 births.',
  },
  {
    num: '03',
    title: 'Tuberous Sclerosis',
    desc: 'Tuberous sclerosis is a syndrome causing kidney cysts, skin changes, and sometimes tumors in organs like the heart. Variants include TSC1, TSC2, and TSC-PKD overlap, combining features of tuberous sclerosis and PKD.',
  },
  {
    num: '04',
    title: 'Nephronophthisis',
    desc: 'Nephronophthisis is a genetic childhood kidney disease with multiple variants and diverse features. It gradually damages kidney function, eventually leading to failure. Diagnosis is difficult, and patients often require dialysis or transplantation for survival.',
  },
];

const TypesOfPKD = () => {
  const sectionStyle = {
    backgroundImage: `url(${TempBackImage})`,
  };

  return (
    <section className="section types-section" style={sectionStyle}>
      <div className="container">
        <h2 className="section-title">Types of Cystic Kidney Diseases</h2>
        <div className="grid-container-2 types-grid">
          {typesData.map((item) => (
            <div className="info-card types-card" key={item.num}>
              <div className="types-card-header">
                <h3 className="types-card-title">{item.title}</h3>
                <span className="types-card-number">{item.num}</span>
              </div>
              <p className="card-description">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TypesOfPKD;